import {Component, Input} from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-page-title-with-back-button',
  templateUrl: './page-title-with-back-button.component.html',
  styleUrl: './page-title-with-back-button.component.scss',
})
export class PageTitleWithBackButtonComponent {
  @Input() title: string = ''
  @Input() description: string = ''
  @Input() backUrl: string = ''
  @Input() backQueryParams: any = null

  goBack(): void {
    if (this.backUrl) {
      this.router.navigate([this.backUrl], { queryParams: this.backQueryParams || {} });
    } else {
      window.history.back();
    }
  }

  constructor(private router: Router) {

  }
}
